






























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { CaptionCollection } from '@/components/organisms/PortalAnnouncementsPanel.vue';
import { UserAnnouncement } from '@/types/type';
import { REL } from '@/utils/consts';

@Component
export default class AnnouncementDetailDialog extends Vue {
  @Prop()
  private userAnnouncement!: UserAnnouncement;

  @Prop()
  private captionCollection!: CaptionCollection;

  private get announcement(): UserAnnouncement {
    return this.userAnnouncement;
  }

  private get captions(): CaptionCollection {
    return this.captionCollection;
  }

  private get displayPeriod(): string {
    return `${this.userAnnouncement.displayStartDate} ~ ${this.userAnnouncement.displayEndDate}`;
  }

  private clickUrl(url: string): void {
    window.open(url, REL);
  }

  private closeButtonClicked(): void {
    this.$emit('closeDialog');
  }
}
